import * as React from 'react';

import { observer } from 'mobx-react';

import { UitkPrimaryFloatingButton, UitkButtonSize } from 'uitk-react-button';
import { UitkFullscreenDialog, UitkDialogContent } from 'uitk-react-dialog';
import { UitkScrim, UitkScrimType } from 'uitk-react-scrim';
import { UitkToolbar, ToolbarType } from 'uitk-react-toolbar';

export interface SearchFormOptionsDialogProps {
  children: React.ReactNode;
  dialogId: string;
  dismissDialogAction?: () => void;
  doneAction: string;
  doneButtonClick?: () => void;
  openCallback?: () => void;
  unmountCallback?: () => void;
  doneActionAccessibility?: string;
  cancelActionAccessibility?: string;
}

@observer
export class SearchFormOptionsDialog extends React.Component<SearchFormOptionsDialogProps> {
  public componentWillUnmount() {
    const { unmountCallback } = this.props;

    if (unmountCallback) {
      unmountCallback();
    }
  }

  public render() {
    const {
      children,
      dialogId,
      dismissDialogAction,
      doneAction,
      doneButtonClick,
      openCallback,
      doneActionAccessibility,
      cancelActionAccessibility
    } = this.props;

    return (
      <UitkFullscreenDialog dialogShow={true} openCallback={openCallback} className="travelers-dialog custom-dialog">
        <UitkToolbar
          action={dismissDialogAction}
          iconLabel={cancelActionAccessibility ? cancelActionAccessibility : 'close'}
          key={`${dialogId}-toolbar`}
          type={ToolbarType.CLOSE}
        />
        <UitkDialogContent key={`${dialogId}-content`} zeroPadding={true} className="all-b-padding-twelve">
          {children}
          <UitkScrim type={UitkScrimType.BUTTON} key={`${dialogId}-button`}>
            <UitkPrimaryFloatingButton
              onClick={doneButtonClick}
              isFullWidth={true}
              size={UitkButtonSize.LARGE}
              text={doneAction}
              aria-label={doneActionAccessibility}
            />
          </UitkScrim>
        </UitkDialogContent>
      </UitkFullscreenDialog>
    );
  }
}
